/**
 * Motion constants shared by the surgery pages.
 * Design master curve (§9): cubic-bezier(0.22, 1, 0.36, 1).
 */
import type { Variants } from 'framer-motion';

export const EASE: [number, number, number, number] = [0.22, 1, 0.36, 1];

/** pageEnter: opacity + y 8→0, 260 ms */
export const pageEnter = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.26, ease: EASE },
} as const;

/** Container with stagger for form sections (90 ms) */
export const staggerSections: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.09 } },
};

/** Section item: y 14→0 + opacity, 340 ms */
export const sectionItem: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.34, ease: EASE } },
};

/** Generic soft entry (editing: no choreography) */
export const simpleEnter: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
};
